import { render, staticRenderFns } from "./RunnerTokens.vue?vue&type=template&id=08905695&"
import script from "./RunnerTokens.vue?vue&type=script&lang=ts&"
export * from "./RunnerTokens.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports